/* eslint-disable */
import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import { BASE_URL, TIMEOUT_PERIOD } from 'constants/api';
import auth from 'utils/auth';
import { DEVICE_ID, APP_VERSION, LANGUAGE_CODE, COUNTRY_CODE, APP_CHANNEL } from 'utils/constants';

export const axiosMiddlewareConfig: any = {
  returnRejectedPromiseOnError: true,
};

interface IError {
  response: any;
  status: string;
}

const instance = axios.create({
  baseURL: BASE_URL,
  timeout: TIMEOUT_PERIOD,
  headers: {
    Accept: 'application/json',
  },
});

instance.interceptors.request.use((request: AxiosRequestConfig) => {
  request.headers = {
    ...request.headers,
    deviceId: DEVICE_ID,
    appVersion: APP_VERSION,
    languageCode: LANGUAGE_CODE,
    countryCode: COUNTRY_CODE,
    channel: APP_CHANNEL,
    sessionId: auth.data?.sessionID || '',
  };

  return request;
});

instance.interceptors.response.use(
  (response: AxiosResponse) => response,
  (error: IError) => {
    const status = Number(((error || {}).response || {}).status);
    if (status !== 401) {
      return Promise.reject(error);
    }

    return Promise.resolve(error.response);
  },
);

export const axiosInstance: AxiosInstance = instance;

export enum AxiosStatus {
  DEFAULT = 'DEFAULT',
  PENDING = 'PENDING',
  SUCCESS = 'SUCCESS',
  FAILURE = 'FAILURE',
  PIN_PENDING = 'PIN_PENDING',
  FIRST_WRONG_PIN = 'FIRST_WRONG_PIN',
  SECOND_WRONG_PIN = 'SECOND_WRONG_PIN',
  FIRST_WRONG_OTP = 'FIRST_WRONG_OTP',
  SECOND_WRONG_OTP = 'SECOND_WRONG_OTP',
  PIN_BLOCKED = 'PIN_BLOCKED',
}
